import { _ } from 'wgnet-awesomejs';
import $ from 'jquery';

import BaseInput from 'source/lib/component/input/base';
import messages from 'messages';

import template from './template.html';
import hint from './hint_content.html';

const NameInput = BaseInput.extend({
    name: 'name-input',
    template,
    initialize(...args) {
        BaseInput.prototype.initialize.apply(this, args);

        this.bindInput();
        this.bindHint();
        this.bindParent();
        this.delegateEvents();

        if (this.getValue() !== '') {
            this.$input.trigger('keyup');
            this.$input.trigger('change');
        }
    },
    getMessage(message) {
        return _.extract(messages, `errors.external-registration-hint.${message}`, '');
    },

    keyup(event) {
        this.components.proxyEvent('error:clear', event, this);

        this.components.proxyEvent('check', event, this);
    },

    bindInput() {
        this.$input = this.$('.js-input');
        this.inputWrapperValidateErrorClass = this.$inputWrapper.data('input-error');
        this.$inputValidateIco = this.$('.js-input-validate-ico');
        this.inputValidateErrorClass = this.$inputValidateIco.data('validate-ico-error');
        this.inputValidateCorrectClass = this.$inputValidateIco.data('validate-ico-correct');
    },
    setInputInitial() {
        this.$inputValidateIco.removeClass(this.inputValidateErrorClass);
        this.$inputValidateIco.removeClass(this.inputValidateCorrectClass);
        this.$inputValidateIco.hide();
        this.$inputWrapper.removeClass(this.inputWrapperValidateErrorClass);
    },
    setInputError() {
        this.isErrored = true;
        this.components.proxyEvent('form:submit:disable', {}, this);
        this.$inputValidateIco.addClass(this.inputValidateErrorClass);
        this.$inputValidateIco.removeClass(this.inputValidateCorrectClass);
        this.$inputValidateIco.show();
        this.$inputWrapper.addClass(this.inputWrapperValidateErrorClass);
    },
    setInputCorrect() {
        this.isErrored = false;
        this.$inputValidateIco.removeClass(this.inputValidateErrorClass);
        this.$inputValidateIco.addClass(this.inputValidateCorrectClass);
        this.$inputValidateIco.show();
        this.$inputWrapper.removeClass(this.inputWrapperValidateErrorClass);
        this.components.proxyEvent('form:submit:enable', {}, this);
    },

    bindHint() {
        this.$hint = $('.js-form-field-hint');
        this.$hintContent = this.$('.js-form-field-hint-content');

        this.events['focus input'] = 'showHint';
        this.events['mouseover .js-form-field-hint-content'] = () => {
            this.hintHover = true;
        };
        this.events['mouseout .js-form-field-hint-content'] = () => {
            this.hintHover = false;
        };
        this.events['mouseleave .js-form-field-hint-content'] = () => {
            this.hintHover = false;
        };
        this.events['blur input'] = 'hideHint';
        this.events.click = 'selectSuggestion';
        $('body').on('click', _.bind(this.hideHint, this));
    },
    showHint() {
        const state = this.$hint.data('current-state');
        if (!state) {
            this.setHintDescription();
            this.$hint.show();
        } else if (state !== 'no-hint') {
            this.$hint.show();
        }
    },
    restoreFocusIfError() {
        if (this.isErrored) {
            this.$hint.show();
            this.$input.focus();
        }
    },
    hideHint() {
        if (this.hintHover) {
            this.$input.focus();
            return;
        }
        this.$hint.hide();
    },
    setHint(state, rendered) {
        this.$hint.data('current-state', state);
        this.$hintContent.html(rendered);
    },
    setHintDescription() {
        this.setHint('description', hint({
            text: this.getMessage('description'),
        }));
    },
    bindParent(...args) {
        BaseInput.prototype.bindParent.apply(this, args);

        this.$root.on('component:all:account-name-validated', _.bind(this.onValidated, this));
        this.$root.on(
            'component:submit-button:click',
            _.bind(this.restoreFocusIfError, this),
        );
        this.$root.on('component:all:account-name-empty', _.bind(this.onEmptyName, this));
    },
    onParentError(event, origin) {
        const errors = _.extract(origin, 'responseJSON.errors.name');

        if (_.isArray(errors) && !_.isEmpty(errors)) {
            const [error] = errors;
            if (error === 'required') {
                this.setHintDescription();
                this.setInputInitial();
            } else {
                this.setHint(error, hint({
                    error: this.getMessage(error),
                }));
                this.setInputError();
            }
            this.$input.focus();
        }
    },

    onValidated(event, data = {}) {
        const {
            banned,
            suggestions,
            spa_id: accountId,
            responseJSON,
        } = data.result || {};
        let errors;

        if (responseJSON) {
            errors = responseJSON.__all__;
            if (!errors && responseJSON.errors) {
                errors = responseJSON.errors.__all__;
            }
        }

        if (banned) {
            this.setHint('banned', hint({
                error: this.getMessage('banned'),
            }));
            this.showHint();
            this.setInputError();
        } else if ((accountId || banned) && _.isArray(suggestions) && !_.isEmpty(suggestions)) {
            this.setHint('exists', hint({
                text: this.getMessage('exists_text'),
                error: this.getMessage('exists_error'),
                suggestions: this.prepareSuggestions(suggestions),
            }));
            this.showHint();
            this.setInputError();
        } else if (_.isArray(errors) && !_.isEmpty(errors)) {
            this.setHint(errors[0], hint({
                error: this.getMessage(errors[0]),
            }));
            this.showHint();
            this.setInputError();
        } else if (!accountId && !banned) {
            this.setHint('no-hint', hint({ text: '' }));
            this.hideHint();
            this.setInputCorrect();
        }
    },

    onEmptyName() {
        this.setHintDescription();
        this.$hint.show();
        this.setInputInitial();
    },

    prepareSuggestions(suggestions) {
        const prepared = [];

        for (let i = 0; i < suggestions.length; i += 1) {
            prepared.push({
                name: suggestions[i],
                last: i === suggestions.length - 1,
            });
        }

        return prepared;
    },
    selectSuggestion(event) {
        const name = $(event.target).data('suggestion');

        if (name) {
            this.hintHover = false;
            this.setValue(name);
            this.$input.trigger('change');

            this.setInputCorrect();
            this.setHintDescription();
            this.hideHint();
        }

        return false;
    },
    change(event) {
        this.value = event.target.value;
        this.components.proxyEvent('change', event, this);
    },
});

export default NameInput;
